<template>
  <FullScreenModal class="outfit-calendar-modal" title="穿搭月曆" btnType="close" @back="backClicked">
    <v-calendar
      class="custom-calendar max-w-full"
      title-position="left"
      :attributes="calendarAttributes"
      disable-page-swipe
      is-expanded
    >
      <template v-slot:day-content="{ day, attributes }">
        <div class="oc-day" @click="clickDay(day)" :class="{selected: selectingDay === day.id, hasCloth: attributes&&attributes.length>0, today: isToday(day.date)}">
          <span class="fs-14px">{{ day.day }}</span>
          <div class="has-cloth-icon" v-if="attributes&&attributes.length>0"><Icon name="outfit-star" size="12" /></div>
        </div>
      </template>
    </v-calendar>

    <div class="outfit-list">
      <div class="outfit-list-item" v-for="(item) in shownOutfits" :key="item.serial" @click.prevent="viewOutfit(item.serial)">
        <div class="item-image">
          <OutfitImage :outfit="item"></OutfitImage>
        </div>
        <div class="item-content fs-14px">
          <div class="fw-bold" v-text="item.situation"></div>
          <div class="place" v-if="item.place">
            <Icon name="location" size="16" />
            <span v-text="item.place"></span>
          </div>
          <div class="weather-temperature">
            <div class="weather-icons" v-text="item.weather"></div>
            <div class="temperature" v-if="item.temperatureSection !== -1" v-text="formattedTemperature(item.temperatureSection)"></div>
          </div>
          <div v-if="!item.feelingUnknown">
            <Icon name="emoji-happy" size="24" v-if="item.feeling === 1" />
            <Icon name="emoji-fine" size="24" v-if="item.feeling === 0" />
            <Icon name="emoji-sad" size="24" v-if="item.feeling === -1" />
          </div>
        </div>
        <!-- <img :src="require('@/assets/icons/dotdotdot.svg')" class="other-btn" @click.stop="otherClicked(item.serial)" /> -->
      </div>
      <!-- <li class="add-li" @click.prevent="createClicked">
        <img class="" :src="require('@/assets/nav_icons/add.png')" />
      </li> -->
    </div>
  </FullScreenModal>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import moment from "moment/moment";
import FullScreenModal from "@/components/FullScreenModal.vue";
import OutfitImage from "@/components/outfit/OutfitImage.vue";

export default {
  name: 'OutfitCalendarModal',
  data() {
    return {
      readingBusyName: 'ReadingOutfitCalendarModal',
      deleteBusyName: 'DeleteOutfitCalendarModal',
      outfits: [],
      focusOutfitSerial: -1,
      selectingDay: '',
    };
  },
  components: {
    OutfitImage,
    FullScreenModal,
  },
  props: {
  },
  computed: {
    ...mapState(['cloths']),
    calendarAttributes() {
      const atrs = [];
      for (const o of this.outfits) {
        const m = moment(o.date);
        atrs.push({
          key: o.serial,
          customData: o,
          dates: m.toDate(),
        });
      }
      return atrs;
    },
    shownOutfits() {
      const outfits = this.outfits.filter((o) => {
        return o.date === this.selectingDay;
      });
      const res = outfits.map((o) => {
        return {
          serial: o.serial,
          outfitPhotos: o.outfitPhotos,
          situation: o.situation,
          place: o.place,
          weather: o.weather,
          temperatureSection: o.temperatureSection,
          feeling: o.feeling,
          feelingUnknown: o.feelingUnknown,
        };
      });
      return res;
    },
  },
  created() {
    const today = moment().format('YYYY-MM-DD');
    this.selectingDay = today;
    this.SETCALENDARDATE(today);
  },
  async mounted() {
    await this.__refresh();
  },
  beforeDestroy() {
    this.clearComponentBusy(this.readingBusyName);
    this.clearComponentBusy(this.deleteBusyName);

    const today = moment().format('YYYY-MM-DD');
    this.SETCALENDARDATE(today);
  },
  methods: {
    ...mapActions('outfit', ['setOutfitId', 'setOutfitType', 'setOutfitData', 'clearOutfitData', 'openOutfitManager']),
    ...mapActions(['showMsgModal', 'appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),
    ...mapMutations(['SETCALENDARDATE']),

    async __refresh() {
      this.appendComponentBusy(this.readingBusyName);
      try {
        const list = await this.$store.dispatch('api/readOutfitListPromise');
        this.outfits.splice(0, this.outfits.length);
        for (const outfit of list) {
          this.outfits.push(outfit);
        }
      } catch(err) {
        this.appendErrorMsg(err.toString());
      } finally {
        this.clearComponentBusy(this.readingBusyName);
      }
    },
    clickDay(day) {
      console.log(day)
      this.selectingDay = day.id;
      this.SETCALENDARDATE(day.id);
    },
    isToday(date) {
      return moment(date).isSame(moment(), 'day');
    },
    viewOutfit(serial) {
      this.clearOutfitData();
      this.setOutfitData({
        outfitId: serial,
        outfitType: 'view',
      });
      this.openOutfitManager();
      // this.focusOutfitSerial = serial;
      // this.showViewOutfit = true;
    },
    formattedTemperature(temp) {
      const temperatureOpt = [
        '-10 ~ 0 ℃',
        '1 ~ 10 ℃',
        '11 ~ 15 ℃',
        '16 ~ 20 ℃',
        '21 ~ 25 ℃',
        '26 ~ 30 ℃',
        '31 ~ 35 ℃',
        '36 ~ 40 ℃',
      ];
      return temperatureOpt[temp];
    },
    backClicked() {
      this.$emit('back');
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/basic";
@font-face {
  font-family: Wweather;
  src: url('~@/assets/font/Writes_weather.ttf');
}
.weather-icons {
  font-family: Wweather;
  margin: 0 .0625rem;
}
.outfit-calendar-modal {
  .outfit-list {
    display: flex;
    flex-direction: column;
    gap: .25rem;
    padding: .5rem 0 2rem;
    .outfit-list-item {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 1rem;
      color: $typography-primary-default;
      background: $color-white;
      padding: 1rem;
    }
    .item-image {
      width: 7rem;
    }
    .item-content {
      display: flex;
      flex-direction: column;
      gap: .5rem;
      min-height: 7rem;
      .place, .weather-temperature {
        display: flex;
        align-items: center;
        gap: .125rem;
      }
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/scss/basic";
.outfit-calendar-modal {
  .box-body {
    background: $color-gray-light;
  }
  .custom-calendar {
    border-radius: 0;
    .vc-nav-popover-container {
      background-color: $typography-primary-default;
      border-color: $typography-secondary-default;
    }
    .vc-header {
      padding: 15px 18px 5px 18px;
      .vc-title {
        color: $typography-primary-default;
        //font-size: $font-small;
      }
    }
    .vc-weekday {
      color: $typography-primary-default;
    }
    .vc-nav-item:focus {
      border-color: $typography-interactive-primary;
    }
    .vc-day {
      width: 100%;
      padding-top: 100%;
    }
    .oc-day {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $typography-secondary-default;
      width: 100%;
      height: 100%;
      &.hasCloth {
        color: $typography-primary-default;
        font-weight: $font-weight-semi-bold;
      }
      &.selected {
        color: $color-white;
        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          content: '';
          background: $typography-primary-default;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 100px;
          transform: translate(-50%, -50%);
        }
      }
      &.today {
        color: $typography-interactive-primary;
        &.selected {
          color: $color-white;
        }
      }
      .fs-14px {
        z-index: 1;
      }
      .has-cloth-icon {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
